export default __webpack_public_path__ + "static/media/talent-leader.453e9aa0.webp";